import React from 'react';
import styles from '../styles/Divider.module.scss';

export default function Divider() {
	return <div className={styles.divider} />;
}
